import { __extends } from "tslib";
import { ValueObject } from '../../base/ddd-types/value-object';
var DocTitleInfo = /** @class */ (function (_super) {
    __extends(DocTitleInfo, _super);
    function DocTitleInfo(jsonObj) {
        var _this = _super.call(this) || this;
        _this.title = '';
        _this.isUserChangeTitle = false;
        _this.jsonObj2Class(jsonObj);
        return _this;
    }
    return DocTitleInfo;
}(ValueObject));
export { DocTitleInfo };
